<template>
  <div>
    <PrimaryHeader app-title="Attribute Toolbox">
      <template v-slot:utilityNav>
        <span
          :title="$t('logout')"
          class="utility-nav-icon material-icons atb-flex"
          @click="logoutClickHandler"
        >
          exit_to_app
        </span>
        <span
          :title="$t('about')"
          class="utility-nav-icon material-icons atb-flex"
          @click="aboutClickHandler"
        >
          info
        </span>
      </template>
    </PrimaryHeader>
    <About v-if="showAbout" @closeAbout="showAbout = false" />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import PrimaryHeader from '@atb-ui/eds-vue/src/components/PrimaryHeader.vue';
  import About from '@/app/shared/components/About.vue';
  import { useAuthStore } from '@/app/shared/stores/auth-store';
  import { mapActions } from 'pinia';

  export default defineComponent({
    name: 'AppPrimaryHeader',
    data() {
      return {
        showAbout: false,
        showPassword: false,
      };
    },
    components: {
      PrimaryHeader,
      About,
    },
    methods: {
      ...mapActions(useAuthStore, ['authLogout']),
      aboutClickHandler() {
        this.showAbout = true;
      },
      logoutClickHandler() {
        this.authLogout();
      },
    },
  });
</script>

<style>
  .utility-nav-icon {
    display: flex;
    align-items: center;
    color: #1d4f91;
    padding: 0 20px;
    height: 100%;
    cursor: pointer;
  }

  .utility-nav-icon:hover {
    color: #426da9;
    background-color: #f3f3f3;
  }
</style>
